import moment from "moment";

export default {
  props: {
    nextCa: {
      required: true,
      type: Array
    }
  },
  data() {
    return {
      blinkDay: 0,
      blinkCaDay: null
    };
  },
  watch: {
    nextCa: function() {
      if (this.CheckUserPermission([7])) {
        if (this.nextCa > 0) {
          this.blinkCaDay = 0;
          this.blinkCaDays();
        } else {
          this.blinkCaDay = null;
        }
      }
    },
    "showVikiMsg.type": function() {
      if (this.showVikiMsg.type === "USER_DEPOSITED") {
        this.blinkDay = 0;
        this.blinkDays();
      } else {
        this.blinkDay = null;
      }
    }
  },
  methods: {
    checkForSelectedCalendar() {},
    checkActiveWeek(week) {
      let week_start = this.getDayIndexInMonth(week, 1, this.startMonthDay);
      let week_end = this.getDayIndexInMonth(week, 7, this.startMonthDay);
      if (week_start < 1) {
        week_start = 1;
      }

      let dateStart = moment(
        Date.UTC(this.activeYearStart, this.activeMonthStart, week_start)
      );
      let dateEnd = moment(
        Date.UTC(this.activeYearStart, this.activeMonthStart, week_end)
      );

      let monthObj = moment(
        Date.UTC(this.activeYearStart, this.activeMonthStart, 1)
      );

      if (dateEnd.isAfter(monthObj.endOf("month"))) {
        dateEnd = monthObj.endOf("month");
      }
      return moment().isBetween(dateStart, dateEnd);
    },

    checkIfNextWeek(week) {
      let week_start = this.getDayIndexInMonth(week, 1, this.startMonthDay);
      let week_end = this.getDayIndexInMonth(week, 7, this.startMonthDay);
      if (week_start < 1) {
        week_start = 1;
      }

      let dateStart = moment(
        Date.UTC(this.activeYearStart, this.activeMonthStart, week_start)
      );
      let dateEnd = moment(
        Date.UTC(this.activeYearStart, this.activeMonthStart, week_end)
      );

      let monthObj = moment(
        Date.UTC(this.activeYearStart, this.activeMonthStart, 1)
      );

      if (dateEnd.isAfter(monthObj.endOf("month"))) {
        dateEnd = monthObj.endOf("month");
      }
      if (moment(moment().add("7", "days")).isBetween(dateStart, dateEnd)) {
      }
      return moment(moment().add("7", "days")).isBetween(dateStart, dateEnd);
    },

    checkIfPrevWeek(week) {
      let week_start = this.getDayIndexInMonth(week, 1, this.startMonthDay);
      let week_end = this.getDayIndexInMonth(week, 7, this.startMonthDay);
      if (week_start < 1) {
        week_start = 1;
      }

      let dateStart = moment(
        Date.UTC(this.activeYearStart, this.activeMonthStart, week_start)
      );
      let dateEnd = moment(
        Date.UTC(this.activeYearStart, this.activeMonthStart, week_end)
      );

      let monthObj = moment(
        Date.UTC(this.activeYearStart, this.activeMonthStart, 1)
      );

      if (dateEnd.isAfter(monthObj.endOf("month"))) {
        dateEnd = monthObj.endOf("month");
      }
      return moment(moment().subtract("1", "week")).isBetween(
        dateStart,
        dateEnd
      );
    },

    checkIfCurrentWeek(week) {
      let week_start = this.getDayIndexInMonth(week, 1, this.startMonthDay);
      let week_end = this.getDayIndexInMonth(week, 7, this.startMonthDay);
      if (week_start < 1) {
        week_start = 1;
      }

      let dateStart = moment(
        Date.UTC(this.activeYearStart, this.activeMonthStart, week_start)
      );
      let dateEnd = moment(
        Date.UTC(this.activeYearStart, this.activeMonthStart, week_end)
      );

      let monthObj = moment(
        Date.UTC(this.activeYearStart, this.activeMonthStart, 1)
      );

      if (dateEnd.isAfter(monthObj.endOf("month"))) {
        dateEnd = monthObj.endOf("month");
      }
      return moment().isBetween(
        moment(dateStart).add("1", "days"),
        moment(dateEnd).add("1", "days")
      );
    },

    checkIfNextMonday(i) {
      return i + 1 === 2;
    },

    blinkDays(day = 0) {
      let elements = [day, day - 1, day - 2, day - 3];
      if (this.blinkDay !== null) {
        elements.map((elm, idx) => {
          let element = document.getElementById("day" + elm);
          $(element).css(
            "background-color",
            `rgba(189,58,255,${1.0 - idx / 4})`
          );
        });

        if (elements[elements.length - 1] > 35) {
          this.blinkDay = 0;
        }
        setTimeout(() => {
          elements.map(elm => {
            let element = document.getElementById("day" + elm);
            $(element).css("background-color", "unset");
          });
          if (this.blinkDay !== null) {
            this.blinkDay++;
            this.blinkDays(this.blinkDay);
          }
        }, 70);
      }
    },

    blinkCaDays(dayUp = 15, dayDown = 15) {
      let elements = [dayUp, dayUp - 1, dayUp - 2, dayUp - 3];
      let elements2 = [dayDown, dayDown + 1, dayDown + 2, dayDown + 3];

      if (this.blinkCaDay !== null && this.blinkCaDay < 3) {
        elements.map((elm, idx) => {
          let element = document.getElementById("day" + elm);
          $(element).css(
            "background-color",
            `rgba(255, 164, 0,${1.0 - idx / 4})`
          );
        });

        elements2.map((elm, idx) => {
          let element = document.getElementById("day" + elm);
          $(element).css(
            "background-color",
            `rgba(255, 164, 0,${1.0 - idx / 4})`
          );
        });

        setTimeout(() => {
          elements.map(elm => {
            let element = document.getElementById("day" + elm);
            $(element).css("background-color", "unset");
          });

          elements2.map(elm => {
            let element2 = document.getElementById("day" + elm);
            $(element2).css("background-color", "unset");
          });
          if (elements[elements.length - 1] > 35 && elements2[0] < 0) {
            this.blinkCaDay++;
            this.blinkCaDays(15, 15);
          } else {
            dayUp++;
            dayDown--;
            this.blinkCaDays(dayUp, dayDown);
          }
        }, 70);
      } else {
        this.blinkCaDay = null;
      }
    },

    getHash() {
      return (
        Math.floor(Math.random() * 10000) +
        1 +
        Math.floor(Math.random() * 10000) +
        1
      );
    },

    formatDate(day){
      let date = moment();
      if(day === 'tomorrow'){
        date = date.add(1,'day');
      }
      return date.format('DD-MM-YYYY') + ' (' +date.format('ddd') +')'
    }
  }
};
